import { render, staticRenderFns } from "./DescripcionAbout.vue?vue&type=template&id=cbae95d8&scoped=true"
import script from "./DescripcionAbout.vue?vue&type=script&lang=js"
export * from "./DescripcionAbout.vue?vue&type=script&lang=js"
import style0 from "./DescripcionAbout.vue?vue&type=style&index=0&id=cbae95d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbae95d8",
  null
  
)

export default component.exports